import React, { useEffect, useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import components from '../../components';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import ApiCall from '../../utils/Api';
const BuyData = () => {
     const [market, setmarket] = useState("")
     const [instrument, setinstrument] = useState("")
     const [institutionName, setinstitutionName] = useState("")
     const [date, setdate] = useState("")
     const navigate = useNavigate();
     const location = useLocation();
     const [BackDropState, setBackDropState] = useState(false)

     console.log('location', location)
     const [unitType, setUnitType] = React.useState('');
     const [ButData, setButData] = useState({
          SDL: "",
          Instrumente: "",
          TimeModus: "",
          Market: "",
          Time: ""
     })
     const handleChange = (event) => {
          setButData({ ...ButData, [event.target.name]: event.target.value, });
     }
     const [ProviderNames, setProviderNames] = useState([])
     useEffect(() => {
          const getProviderName = async () => {
               try {
                    const data = await ApiCall.SECURE_API.get("/provider/getNames")
                    setProviderNames(data.data.data)

               } catch (error) {
                    console.log("Error getting provider names:", error)

               }
          }
          getProviderName()

     }, [])

     // const handleChange = (event) => {
     //   setAge(event.target.value);
     // };
     return (
          <div style={{ width: "100%" }}>
               <components.Loader.Back_Drop state={BackDropState} />

               
               <div style={{ display: "flex", justifyContent: "center",flexDirection:"column" }}>
               <span >
                    <div style={{ padding:20, fontSize:30,fontWeight:"bold" }}>
                         <span >Select Data for Purchase</span>
                      
                    </div>


               </span>
                    <div style={{ display: "flex", backgroundColor: "white", padding: 30, flexDirection: "column", alignItems: "center", justifyContent: "space-around", width: "90%" }}>
                         {/* <div style={{width:"95%",padding:27}} className='ProviderTitle'>
                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                                    <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                                        <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Provider Address</span>
                                    </div>
                                        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:10}}>
                                        <TextField style={{width:"100%"}} id="outlined-basic" label="Enter Provider Address" variant="outlined" />
                                        <div >
                                        <Button style={{paddingLeft:25,paddingRight:25,paddingTop:10,paddingBottom:10,marginLeft:10}} variant="contained">Check</Button>    
                                        </div>
                                        </div>
                                </div>
                            
                            
                              

                            </div> */}
                         {/* <div style={{ display: "flex", justifyContent: "center", width: "90%" }}> */}
                              <div style={{ display: "flex", flexDirection: "row", width: "90%",  justifyContent: "space-between", alignItems: "center" }}>
                                   <FormControl style={{ width: "90%" }} >
                                        <InputLabel id="demo-simple-select-label">Select SDL</InputLabel>
                                        <Select
                                             labelId="demo-simple-select-label"
                                             id="demo-simple-select"
                                             name='SDL'
                                             value={institutionName}
                                             label="Select SDL"
                                             // onChange={(e) => setinstrument(e.target.value)}

                                             onChange={(e)=>{
                                                  setinstitutionName(e.target.value)
                                             }
                                             }
                                        >
                                              <MenuItem value="">Unselect</MenuItem>
                                             {ProviderNames.map((item,index) => {
                                                  return (
                                                                                     
                                                            <MenuItem key={index} value={item}>{item}</MenuItem>
                                                       
                                                  )
                                             })

                                             }
                                        </Select>
                                   </FormControl>
                                   <FormControl style={{ width: "90%" }} >
                                        <InputLabel id="demo-simple-select-label">Select Instrument</InputLabel>
                                        <Select
                                             labelId="demo-simple-select-label"
                                             id="demo-simple-select"
                                             value={instrument}
                                             label="Select Instrument"
                                             onChange={(e) => setinstrument(e.target.value)}
                                             name='Instrumente'
                                        >
                                             <MenuItem value="">Unselect</MenuItem>
                                             <MenuItem value="ETH">TDU</MenuItem>
                                             <MenuItem value="HFDU">HFDU</MenuItem>
                                             <MenuItem value="Equities">Equities</MenuItem>
                                             <MenuItem value="SDU">SDU</MenuItem>

                                        </Select>
                                   </FormControl>
                                   <FormControl style={{ width: "90%" }} >
                                        <InputLabel id="demo-simple-select-label">Select Market</InputLabel>
                                        <Select
                                             labelId="demo-simple-select-label"
                                             id="demo-simple-select"
                                             value={market}
                                             name='Market'
                                             label="Select Market"
                                             onChange={(e) => setmarket(e.target.value)}
                                        >
                                             <MenuItem value="">Unselect</MenuItem>
                                             <MenuItem value="FX">FX</MenuItem>
                                             <MenuItem value="Crypto">Crypto (CRY)</MenuItem>
                                             <MenuItem value="Commodities">Commodities (COM)</MenuItem>
                                             <MenuItem value="Equities">Equities (EQU)</MenuItem>
                                        </Select>
                                   </FormControl>
                                   <FormControl style={{ width: "90%" }} >
                                        <InputLabel id="demo-simple-select-label">Date</InputLabel>
                                        <Select
                                             labelId="demo-simple-select-label"
                                             id="demo-simple-select"
                                             value={date}
                                             name='Market'
                                             label="Select Market"
                                             onChange={(e) => setdate(e.target.value)}
                                        >
                                             <MenuItem value="">Unselect</MenuItem>
                                             <MenuItem value="1D">1D</MenuItem>
                                             <MenuItem value="1W">1W</MenuItem>
                                             <MenuItem value="1M">1M</MenuItem>
                                             <MenuItem value="3M">3M</MenuItem>
                                             <MenuItem value="1Y">1Y</MenuItem>
                                             <MenuItem value="2Y">2Y</MenuItem>
                                             <MenuItem value="5Y">5Y</MenuItem>



                                        </Select>
                                   </FormControl>
                              </div >

                         {/* </div> */}
                         <div style={{ width: "98%", marginTop: 40 }}>
                              <components.Table.BuyDataTable date={date} instrument={instrument} market={market} institutionName={institutionName} setBackDropState={setBackDropState} BackDropState={BackDropState} />
                         </div>

                    </div>
               </div>

          </div>
     )
}

export default BuyData